import { SchemaFactory } from 'fluid-framework';
const schemaFactory = new SchemaFactory('datapad.location');
export class Location extends schemaFactory.object('location', {
    name: schemaFactory.string,
    resourceUrl: schemaFactory.optional(schemaFactory.string),
}) {
}
//# sourceMappingURL=Location.js.map